<template>
  <div id="gifts-edit-page">
    <Drawer ref="drawer">
      <component
        v-if="component"
        :is="component"
        :data="dataDrawer"
        @openDrawer="openDrawer"
      ></component>
    </Drawer>

    <div class="gift-edit-page-desktop">
      <div class="gift-edit-header columns is-gapless">
        <div class="gift-edit-header-totals column is-one-quarter">
          <div>
            Total de produtos:
            <span class="totals-highlight">{{ giftsList.length }}</span>
          </div>
          <div class="gift-menu-divider"></div>
          <div>
            Total da Lista:
            <span class="totals-highlight">
              {{ priceGiftsListTotal | currency }}
            </span>
          </div>
          <div class="gift-menu-divider"></div>
        </div>
        <div class="column gift-edit-search">
          <div class="gift-list-search-wrapper">
            <img :src="searchIcon" class="icon-search" />
            <input
              v-on:keyup="queringPag()"
              type="text"
              v-model="query"
              class="gift-list-search"
              placeholder="buscar produto na minha lista"
            />
          </div>
        </div>
      </div>
      <div class="gift-edit-content columns">
        <div class="gift-filters column is-one-fifth">
          <div class="gift-filters-category">
            <div class="gift-filters-category-title">Categoria</div>
            <p
              v-for="(category, index) in giftsListCategoriesSaved"
              :key="index"
              class="gift-filters-item"
            >
              <b-field>
                <b-checkbox
                  v-model="categoriesSelected"
                  :native-value="category"
                >
                  {{ category.nome }}
                  <span class="counter-colored">
                    ({{ countGiftsByCategory(category) }})
                  </span>
                </b-checkbox>
              </b-field>
            </p>
          </div>
          <div class="gift-filter-divider"></div>
          <div class="gift-filters-range">
            <div class="gift-filters-range-title">Variação de preço</div>
            <b-field
              v-for="(range, index) in filterRanges"
              :key="index"
              class="gift-filters-range-values"
            >
              <b-radio v-model="rangeSelected" :native-value="range">
                {{ range.label }}
                <span class="counter-colored">
                  ({{ countGiftsByPrice(range) }})
                </span>
              </b-radio>
            </b-field>
          </div>
          <div class="gift-filter-divider"></div>
          <div
            v-if="filtersSelectedCount"
            class="gift-filter-clean"
            @click="cleanFilters"
          >
            <div><img :src="closeClean" /> Limpar filtros</div>
            <span class="selection-count">{{ filtersSelectedCount }}</span>
          </div>
        </div>
        <div class="gift-items column">
          <b-notification
            v-if="!published"
            type="is-warning is-light"
            role="alert"
            class="mb-2 has-text-centered"
            :closable="false"
          >
            <router-link
              :to="{
                path: '/presentes/configurar-lista?tab=visibilidade-da-lista',
              }"
            >
              <strong>
                Os presentes não estão exibidos no site para os convidados. Para
                exibi-los, <span class="has-text-underline">publique</span> a
                sua lista.
              </strong>
            </router-link>
          </b-notification>
          <div class="filtering-buttons">
            <div class="columns">
              <div class="column filtering-select">
                <div class="csr-select-order">
                  <span class="csr-select-order-title">Ordenar:</span>
                  <select v-model="listOrder">
                    <option value="last">Adicionados por último</option>
                    <option value="az">A-Z</option>
                    <option value="small">Menor valor</option>
                    <option value="big">Maior valor</option>
                  </select>
                </div>
              </div>
              <div
                class="column filtering-list-options"
                style="text-align: right"
              >
                <button
                  @click="openModalToConfirmDeleteGiftsList"
                  type="button"
                  class="filter-button"
                >
                  <img :src="trashImg" />Excluir lista
                </button>
                <button v-if="published && false" class="filter-button">
                  <img :src="eyeImg" />Visualizar lista
                </button>
              </div>
            </div>
          </div>
          <div class="gifts-list-cards">
            <div class="columns is-multiline">
              <div
                class="column is-one-third-desktop is-one-quarter-widescreen"
              >
                <div @click="createGiftOrAutomaticList" class="gift-items-card">
                  <div class="gift-items-card-content-create">
                    <img class="gift-items-card-image-create" :src="giftPlus" />
                    <div class="gift-items-card-title-create">
                      Criar presente ou adicionar listas prontas
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-for="gift in giftsFiltered"
                :key="gift.id"
                class="column is-one-third-desktop is-one-quarter-widescreen"
              >
                <GiftCard
                  :name="gift.nome"
                  :price="gift.valor_final"
                  :image="getUrlImage(gift)"
                  @closed="delGift(gift.id)"
                  @clicked="editGift(gift, 'DrawerCreateGift')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gift-edit-page-mobile">
      <div class="gift-edit-header">
        <div class="gift-edit-header-totals">
          <div>
            Total de produtos:
            <span class="totals-highlight">
              {{ giftsList.length }}
            </span>
          </div>
          <div class="gift-menu-divider"></div>
          <div>
            Total da Lista:
            <span class="totals-highlight">
              {{ priceGiftsListTotal | currency }}
            </span>
          </div>
        </div>
        <div class="gift-edit-search">
          <div class="gift-list-search-wrapper">
            <img :src="searchIcon" class="icon-search" />
            <input
              v-on:keyup="queringPag()"
              type="text"
              v-model="query"
              class="gift-list-search"
              placeholder="buscar produto na minha lista"
            />
          </div>
        </div>
      </div>
      <div class="gift-edit-content">
        <div class="gift-filters columns is-mobile">
          <b-sidebar
            fullheight="fullheight"
            :fullwidth="fullwidth"
            :overlay="overlay"
            :right="right"
            v-model="open"
          >
            <div class="filter-gifts-sidebar">
              <div class="filter-header">
                <img
                  @click="closeMobileFilters"
                  class="filter-header-back"
                  :src="arrowBack"
                />
                Filtrar e ordenar
                <span v-if="filtersSelectedCount" class="counter">
                  {{ filtersSelectedCount }}
                </span>
              </div>
              <div class="filter-content">
                <div class="filter-content-category-title">Categoria</div>

                <p
                  v-for="(category, index) in giftsListCategoriesSaved"
                  :key="index"
                  class="gift-filters-item"
                >
                  <b-field>
                    <b-checkbox
                      v-model="categoriesSelected"
                      :native-value="category"
                    >
                      {{ category.nome }}
                      <span class="counter-colored">
                        ({{ countGiftsByCategory(category) }})
                      </span>
                    </b-checkbox>
                  </b-field>
                </p>

                <div class="gift-filter-divider"></div>
                <div class="gift-filters-range">
                  <div class="gift-filters-range-title">Variação de preço</div>
                  <b-field
                    v-for="(range, index) in filterRanges"
                    :key="index"
                    class="gift-filters-range-values"
                  >
                    <b-radio v-model="rangeSelected" :native-value="range">
                      {{ range.label }}
                      <span class="counter-colored">
                        ({{ countGiftsByPrice(range) }})
                      </span>
                    </b-radio>
                  </b-field>
                </div>
                <div class="gift-filter-divider"></div>
                <div class="gift-filters-range">
                  <div class="gift-filters-range-title">Ordenar</div>
                  <b-field class="gift-filters-range-values">
                    <b-radio v-model="listOrder" native-value="last">
                      Adicionados por último
                    </b-radio>
                  </b-field>
                  <b-field class="gift-filters-range-values">
                    <b-radio v-model="listOrder" native-value="az">A-Z</b-radio>
                  </b-field>
                  <b-field class="gift-filters-range-values">
                    <b-radio v-model="listOrder" native-value="small">
                      Menor valor
                    </b-radio>
                  </b-field>
                  <b-field class="gift-filters-range-values">
                    <b-radio v-model="listOrder" native-value="big">
                      Maior valor
                    </b-radio>
                  </b-field>
                </div>
              </div>
            </div>
            <div class="filter-gifts-sidebar-footer">
              <div class="wrapper-buttons">
                <button
                  class="button is-outlined btn-clean"
                  :disabled="!filtersSelectedCount"
                  @click="cleanFilters"
                >
                  Limpar filtros
                </button>
                <button
                  class="button is-primary"
                  :disabled="!filtersSelectedCount && !changedListOrder"
                  @click="closeMobileFilters"
                >
                  Aplicar filtros
                </button>
              </div>
            </div>
          </b-sidebar>

          <div class="column is-quarter-fifths-mobile">
            <button
              class="filter-button"
              :class="{
                'filter-button-active': !!filtersSelectedCount,
              }"
              @click="openMobileFilters()"
            >
              <img :src="filterImg" /> Filtrar e ordenar
              <span v-if="filtersSelectedCount" class="filter-count">{{
                filtersSelectedCount
              }}</span>
            </button>
          </div>
          <div class="column is-one-fifth-mobile">
            <button
              class="filter-button"
              @click="openModalToConfirmDeleteGiftsList"
            >
              <img :src="trashImg" />
            </button>
          </div>
          <div v-if="published && false" class="column is-one-fifth-mobile">
            <button class="filter-button">
              <img :src="eyeImg" />
            </button>
          </div>
        </div>

        <b-notification
          v-if="!published"
          type="is-warning is-light"
          role="alert"
          class="mt-2 mb-4 has-text-centered"
          :closable="false"
        >
          <router-link
            :to="{
              path: '/presentes/configurar-lista?tab=visibilidade-da-lista',
            }"
          >
            <strong>
              Os presentes não estão exibidos no site para os convidados. Para
              exibi-los, <span class="has-text-underline">publique</span> a sua
              lista.
            </strong>
          </router-link>
        </b-notification>

        <div class="gift-items">
          <div class="columns is-multiline">
            <div class="column">
              <div @click="createGiftOrAutomaticList" class="gift-items-card">
                <div class="gift-items-card-content-create">
                  <img class="gift-items-card-image-create" :src="giftPlus" />
                  <div class="gift-items-card-title-create">
                    Criar presente ou adicionar listas prontas
                  </div>
                </div>
              </div>
            </div>

            <div class="column" v-for="gift in giftsFiltered" :key="gift.id">
              <GiftCard
                :name="gift.nome"
                :price="gift.valor_final"
                :image="getUrlImage(gift)"
                @closed="delGift(gift.id)"
                @clicked="editGift(gift, 'DrawerCreateGift')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalActionConfirmation
      ref="modalConfirmDeleteList"
      message="Tem certeza que deseja excluir toda a sua lista de presentes?"
      @confirmed="delGiftsFromList"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/img/search-icon.svg'
import uploadImage from '@/assets/img/upload_image.png'
import closeImage from '@/assets/img/close-gift.svg'
import giftEdit from '@/assets/img/gift-edit.svg'
import giftPlus from '@/assets/img/gift-plus.svg'
import closeClean from '@/assets/img/close.svg'

import filterImg from '@/assets/img/filter.svg'
import eyeImg from '@/assets/img/config-eye.svg'
import trashImg from '@/assets/img/trash-grey.svg'
import arrowBack from '@/assets/img/arrow-back.svg'

import ModalActionConfirmation from '@/components/Shared/ModalActionConfirmation.vue'
import Drawer from '@/components/Drawer/Drawer.vue'
import DrawerCreateGift from './DrawerCreateGift.vue'
import DrawerReadyList from './DrawerReadyList.vue'
import DrawerGiftByCategory from './DrawerGiftByCategory.vue'
import DrawerStartGiftList from './DrawerStartGiftList.vue'
import GiftCard from './GiftCard.vue'

import LazyImageLoader from '@/plugins/lazy-image-loader'
import GiftsApi from '@/lib/api/Gifts'
import {
  sortGifts,
  filterPriceRanges,
  filterGiftsByPriceRange,
  filterGiftsByCategories,
} from './GiftListUtils'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL
const lazyImageLoader = new LazyImageLoader()

export default {
  name: 'GiftEditPage',
  components: {
    Drawer,
    GiftCard,
    DrawerCreateGift,
    DrawerReadyList,
    DrawerGiftByCategory,
    DrawerStartGiftList,
    ModalActionConfirmation,
  },
  data() {
    return {
      open: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: true,

      query: null,
      searchIcon,
      uploadImage,
      giftPlus,
      closeImage,
      closeClean,
      giftEdit,
      filterImg,
      eyeImg,
      trashImg,
      arrowBack,

      giftListCategories: [],
      categoriesSelected: [],
      rangeSelected: undefined,
      filterRanges: [...filterPriceRanges],
      timeoutDeletingGiftId: undefined,

      published: true,
      giftsList: [],
      listOrder: 'small',
      changedListOrder: false,
      component: '',
      dataDrawer: {},
    }
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
      giftsListSaved: 'gifts/getGiftsList',
      giftsListTotalAmount: 'gifts/getGiftsListAmount',
      giftsListCategoriesSaved: 'gifts/getGiftsListCategories',
    }),

    filtersSelectedCount() {
      let count = this.rangeSelected ? 1 : 0
      count = count + this.categoriesSelected.length
      return count
    },

    giftsFiltered() {
      const categories = this.categoriesSelected
      const range = this.rangeSelected
      let filtered = this.giftsList

      filtered = filterGiftsByCategories(filtered, categories)
      filtered = filterGiftsByPriceRange(filtered, range)
      filtered = sortGifts(filtered, this.listOrder)

      return filtered
    },

    priceGiftsListTotal() {
      return this.giftsListSaved
        .map((gift) => parseFloat(gift.valor_final))
        .reduce((accumulator, current) => accumulator + current, 0)
    },
  },

  watch: {
    giftsListSaved(newValue) {
      this.giftsList = [...newValue]
    },

    giftsFiltered() {
      lazyImageLoader.start()
    },
  },

  created() {
    lazyImageLoader.start()
  },

  mounted() {
    this.giftsList = this.giftsListSaved
    this.getGiftListConfig()
  },

  methods: {
    ...mapActions({
      fetchGiftsList: 'gifts/fetchGiftsList',
      setGiftsList: 'gifts/setGiftsList',
      setSaving: 'gifts/setSaving',
      setIsEditing: 'gifts/setIsEditing',
    }),

    openDrawer(event) {
      this.component = event.component
      this.dataDrawer = undefined
      this.$refs.drawer.open(event.config)
    },

    editGift(gift, component) {
      this.component = component
      this.dataDrawer = { ...gift }
      this.$refs.drawer.open({ title: 'Editar presente' })
    },

    createGiftOrAutomaticList() {
      this.component = 'DrawerStartGiftList'
      this.dataDrawer = undefined
      this.$refs.drawer.open({
        title: 'Adicionar presente',
        size: 'normal',
      })
    },

    countGiftsByPrice(range) {
      let gifts = [...this.giftsList]

      gifts = filterGiftsByPriceRange(gifts, range)
      gifts = filterGiftsByCategories(gifts, this.categoriesSelected)

      return gifts.length
    },

    countGiftsByCategory(category) {
      let gifts = [...this.giftsList]

      gifts = filterGiftsByPriceRange(gifts, this.rangeSelected)
      gifts = filterGiftsByCategories(gifts, [category])

      return gifts.length
    },

    cleanFilters() {
      this.rangeSelected = undefined
      this.categoriesSelected = []
      this.listOrder = 'small'
      this.closeMobileFilters()
    },

    getUrlImage(gift) {
      if (gift.img_user == '1') {
        return (
          `${API_LEGACY_URL}/dados/sitenoivos/wed${this.wedId}/presentes/` +
          gift.img
        )
      } else {
        return `${API_LEGACY_URL}/img/presentes/` + gift.img
      }
    },

    openModalToConfirmDeleteGiftsList() {
      this.$refs.modalConfirmDeleteList.open()
    },

    delGiftsFromList() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.delGiftsFromList().then((response) => {
        if (!response.data.success) throw 'error when trying to delete list'
        this.setGiftsList([])
        this.setSaving(true)
      })
    },

    delGift(giftId) {
      this.giftsList = this.giftsListSaved.filter((gift) => gift.id !== giftId)

      const giftsApi = new GiftsApi(this.logonToken)

      this.setSaving(true)
      this.setGiftsList(this.giftsList)

      giftsApi.delGift(giftId).then((response) => {
        if (!response.data.success && !response.data.id)
          throw 'error when trying to delete a product'
      })
    },

    getGiftListConfig() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.getGiftListConfig().then((response) => {
        this.published = response.data.published
      })
    },

    queringPag() {
      const value = String(this.query).toLowerCase()
      this.giftsList = this.giftsListSaved.filter((gift) =>
        gift.nome.toLowerCase().includes(value)
      )
    },
    getGiftValue(value) {
      value = parseFloat(value)
      return value.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },
    openMobileFilters() {
      this.setIsEditing(true)
      this.open = true
    },
    closeMobileFilters() {
      this.setIsEditing(false)
      this.open = false
      this.changedListOrder = false
    },
    applyFilters() {
      this.open = false
    },
  },
}
</script>
<style lang="scss" scoped>
.gift-edit-page-mobile {
  display: block;

  @media (min-width: 1024px) {
    display: none;
  }

  .gift-edit-header {
    margin-top: 32px;
    height: 64px;

    .gift-edit-header-totals {
      display: flex;
      font-size: 14px;
      font-weight: 700;
      color: $neutral;
      width: auto;
      height: 64px;
      vertical-align: middle;
      align-items: center;

      .totals-highlight {
        color: #3dafb0;
      }

      .gift-menu-divider {
        border-left: 1px solid $neutrallight;
        height: 24px;
        align-self: center;
        margin: 0 14px;
      }
    }

    .gift-edit-search {
      display: block;
      align-items: center;
      width: 100%;

      .gift-list-search-wrapper {
        width: 100%;
        height: 56px;
        background-color: #fff;
        border-radius: 16px;
        margin-left: 0px;
        margin-right: 0px;
        display: flex;
        align-items: center;
        float: left;
        margin-bottom: 35px;

        border: 1.5px solid #dde7f1;
        color: $neutral;

        .icon-search {
          width: 16px;
          height: 16px;
          margin-left: 20px;
          opacity: 0.5;
        }

        .gift-list-search {
          background-color: #fff !important;
          border-radius: 16px;
          width: 100%;
          height: 52px;
          border-color: transparent;

          float: left;
          font-size: 16px;
          color: $neutral;
        }

        .gift-list-search::placeholder {
          color: $neutral;
        }

        .gift-list-search:focus,
        input:focus {
          outline: none;
        }
      }
    }
  }

  .gift-edit-content {
    .gift-filters {
      .filter-button {
        color: $neutral;
        background-color: $neutrallightest;
        border: 1px solid #e9eef3;
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        display: flex;
        height: 48px;
        border-radius: 8px;
        align-items: center;
        justify-content: center;

        img {
          margin: 0 8px;
        }

        &.filter-button-active {
          border: 1px solid $primary;
          .filter-count {
            color: #fff;
            background-color: $primary;
            margin-left: 8px;
            border-radius: 100px;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 2px;
          }
        }
      }
    }

    .gift-items {
      .columns {
        display: flex;
        margin: 0 -8px;
      }

      .column {
        flex: none;
        width: 100%;
        padding: 8px;

        @media screen and (min-width: 359px) {
          width: 50%;
        }

        @media screen and (min-width: 500px) {
          width: 33.3333%;
        }

        @media screen and (min-width: 760px) {
          width: 25%;
        }
      }

      .gift-items-card {
        height: 294px;
        width: 100%;
        text-align: center;
        display: inline-flex;

        .gift-items-card-content-create {
          width: 100%;
          padding: 8px;
          border: 2px dashed $neutrallight;
          box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
          border-radius: 8px;
          background-color: $neutrallightest;

          .gift-items-card-image-create {
            width: 55px;
            height: 55px;
            margin-top: 60px;
            margin-bottom: 8px;
          }

          .gift-items-card-title-create {
            font-size: 16px;
            font-weight: 700;
            color: $neutral;
            height: 32px;
          }
        }

        .gift-items-card-content {
          position: relative;
          width: 100%;
          padding: 16px 0;
          border: 1px solid #dde7f1;
          box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
          border-radius: 16px;

          .gifts-items-card-close {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 6px;
            right: 6px;
            bottom: auto;
            left: auto;
            z-index: 1;
            text-align: right;
            cursor: pointer;
            filter: drop-shadow(0px 2px 4px rgba(93, 117, 141, 0.2));
          }

          .gift-items-card-image {
            width: 144px;
            height: 144px;
            border-radius: 16px;
            margin-bottom: 8px;
            cursor: pointer;
            object-fit: cover;
          }

          .gift-items-card-title {
            font-size: 14px;
            font-weight: 400;
            color: $neutral;
            margin-bottom: 8px;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-left: 12px;
            padding-right: 12px;
            line-height: 16px;
            cursor: pointer;
          }

          .gift-items-card-value {
            font-size: 18px;
            font-weight: 700;
            color: $neutral;
            height: 20px;
            margin-bottom: 12px;
            cursor: pointer;
          }

          .gift-items-card-edit {
            font-size: 14px;
            color: #3dafb0;
            display: inline-flex;
            vertical-align: middle;
            cursor: pointer;

            img {
              width: 16px;
            }
          }
        }
      }
    }
  }
}

//
//
// DESKTOP SECTION ---------------------------------------------------------------------------
.gift-edit-page-desktop {
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }

  .gift-edit-header {
    margin-top: 32px;
    height: 88px;

    .gift-edit-header-totals {
      display: flex;
      font-size: 16px;
      font-weight: 700;
      color: $neutral;
      width: auto;

      vertical-align: middle;
      align-items: center;

      .totals-highlight {
        color: #3dafb0;
      }

      .gift-menu-divider {
        width: 1px;
        height: 24px;
        align-self: center;
        margin: 0 24px;
        background-color: $neutrallight;
      }
    }

    .gift-edit-search {
      display: flex;
      align-items: center;

      .gift-list-search-wrapper {
        width: 100%;
        height: 56px;
        background-color: #fff;
        border-radius: 16px;
        margin-top: 32px;
        display: flex;
        align-items: center;
        float: left;
        margin-bottom: 35px;

        border: 1.5px solid #dde7f1;
        color: $neutral;

        .icon-search {
          width: 16px;
          height: 16px;
          margin-left: 20px;
          opacity: 0.5;
        }

        .gift-list-search {
          background-color: #fff !important;
          border-radius: 16px;
          width: 100%;
          height: 54px;
          border-color: transparent;

          float: left;
          font-size: 16px;
          color: $neutral;
        }

        .gift-list-search::placeholder {
          color: $neutral;
        }

        .gift-list-search:focus,
        input:focus {
          outline: none;
        }
      }
    }
  }

  .gift-edit-content {
    @media (min-width: 900px) and (max-width: 1400px) {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }

    .gift-filters {
      .gift-filters-category {
        .gift-filters-category-title {
          display: flex;
          min-height: calc(84px - 1.5rem);
          margin-bottom: 1.5rem;
          align-items: center;
          font-size: 16px;
          font-weight: 700;
          color: $neutral;
          text-align: left;
        }

        .gift-filters-item {
          font-size: 16px;
          color: $neutral;
          text-align: left;
          margin-bottom: 16px;

          .counter-colored {
            color: $primary;
          }
        }
      }

      .gift-filter-divider {
        border-bottom: 2px solid $neutrallightest;
        max-width: 208px;
        width: 100%;
        align-self: center;
        height: 2px;
        margin-top: 30px;
        margin-bottom: 30px;
      }

      .gift-filter-clean {
        color: $neutral;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        border: 1px solid $primary;
        border-radius: 16px;
        height: 56px;
        padding-top: 19px;
        padding-bottom: 18px;
        padding-left: 20px;
        line-height: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .selection-count {
          color: #fff;
          background-color: $primary;
          border-radius: 100px;
          width: 24px;
          height: 24px;
          display: inline-flex;
          align-items: center;
          vertical-align: middle;
          justify-content: center;
          margin-right: 16px;
        }

        img {
          padding-right: 10px;
        }
      }

      .gift-filters-range {
        .gift-filters-range-title {
          font-size: 16px;
          font-weight: 700;
          color: $neutral;
          margin-bottom: 42px;
          text-align: left;
        }

        .gift-filters-range-values {
          text-align: left;
          color: $neutral;

          .counter-colored {
            color: $primary;
          }
        }
      }
    }

    .gift-items {
      text-align: left;

      .filtering-buttons {
        .filtering-select {
          display: flex;
          text-align: left;
          align-items: center;
          color: $neutral;
          font-size: 16px;

          .csr-select-order {
            .csr-select-order-title {
              font-weight: 700;
            }

            select {
              border: none !important;
              background-color: #fff;
              outline: none;
              color: $neutral;
              font-size: 16px;
              border-radius: 8px;

              option {
                color: $neutral;
                font-weight: 400;
                font-size: 16px;
                border-radius: 8px;
              }
            }

            select:focus-visible {
              border: none !important;
              background-color: #fff;
              outline: none;
            }
          }
        }

        .filtering-list-options {
          .filter-button {
            cursor: pointer;
            align-items: center;
            justify-content: center;
            vertical-align: middle;
            display: inline-flex;
            border: none;
            margin-right: 16px;
            padding-left: 16px;
            padding-right: 16px;
            padding-top: 18px;
            padding-bottom: 18px;
            border-radius: 16px;
            font-size: 16px;
            font-weight: 400;
            color: $neutral;
            background-color: transparent;

            &:hover {
              background-color: $neutrallightest;
            }

            &:last-child {
              margin-right: 0;
            }
          }

          img {
            margin-right: 8px;
          }
        }
      }

      .gifts-list-cards {
        margin-top: 11px;
      }

      .gift-items-card {
        text-align: center;
        vertical-align: top;
        cursor: pointer;
        flex: 1;
        height: 100%;

        .gift-items-card-content-create {
          min-height: 374px;
          height: 100%;
          padding: 16px;
          border: 2px dashed $neutrallight;
          box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
          border-radius: 16px;
          background-color: $neutrallightest;

          .gift-items-card-image-create {
            width: 96px;
            height: 96px;
            margin-top: 80px;
            margin-bottom: 16px;
          }

          .gift-items-card-title-create {
            font-size: 18px;
            font-weight: 700;
            color: $neutral;
            height: 32px;
          }
        }

        .gift-items-card-content {
          position: relative;
          height: 100%;
          padding: 16px;
          border: 1px solid #dde7f1;
          box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
          border-radius: 16px;

          .gifts-items-card-close {
            width: 32px;
            height: 32px;
            position: absolute;
            text-align: right;
            top: 6px;
            right: 6px;
            bottom: auto;
            left: auto;
            z-index: 1;
            cursor: pointer;
            transition: 0.15s all ease-in-out;
            filter: drop-shadow(0px 2px 4px rgba(93, 117, 141, 0.2));
          }

          .gifts-items-card-close:hover {
            width: 35px;
            height: 35px;
            margin-left: 178px;
          }

          .gift-items-card-image {
            width: 208px;
            height: 208px;
            border-radius: 16px;
            margin-bottom: 8px;
            object-fit: cover;
          }

          .gift-items-card-title {
            font-size: 14px;
            font-weight: 400;
            color: $neutral;
            margin-bottom: 8px;
            height: 34px;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 40px;
            padding-left: 12px;
            padding-right: 12px;
          }

          .gift-items-card-value {
            font-size: 18px;
            font-weight: 700;
            color: $neutral;
            height: 40px;
          }

          .gift-items-card-edit {
            font-size: 14px;
            color: #3dafb0;
            display: inline-flex;
            vertical-align: middle;
            cursor: pointer;

            img {
              width: 16px;
            }
          }
        }
      }
    }
  }
}

.filter-gifts-sidebar {
  .filter-header {
    display: flex;
    align-items: center;
    height: 64px;
    border: 1px solid $neutrallight;
    box-shadow: 0px 2px 4px rgba(93, 117, 141, 0.3);
    padding: 22px;
    font-size: 22px;
    font-weight: 700;
    color: $neutral;
    position: fixed;
    width: 100%;
    background: #fff;
    z-index: 1;

    img {
      padding-right: 22px;
    }
  }

  .filter-content {
    position: static;
    padding-top: 16px;
    padding-left: 32px;
    padding-right: 32px;

    .filter-content-category-title {
      font-size: 20px;
      font-weight: 700;
      color: $neutral;
      margin-top: 96px;
      margin-bottom: 24px;
    }

    .gift-filters-item {
      font-size: 16px;
      font-weight: 400;
      color: $neutral;
      margin-bottom: 26px;
    }

    .gift-filter-divider {
      border-bottom: 2px solid $neutrallightest;
      width: auto;
      align-self: center;
      height: 2px;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .gift-filters-range {
      .gift-filters-range-title {
        font-size: 20px;
        font-weight: 700;
        color: $neutral;
        margin-bottom: 24px;
      }

      .gift-filters-range-values {
        font-size: 16px;
        font-weight: 400;
        color: $neutral;
        margin-bottom: 26px;
      }
    }

    .gift-filters-range:nth-last-child(2) {
      margin-bottom: 192px !important;
    }
  }
}

.filter-gifts-sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: auto;
  right: 0;
  bottom: 0px;
  left: 0;
  margin-bottom: 0px;
  width: 100%;
  background: #fff;
  z-index: 1;
  min-height: 162px;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  border-top: 2px solid $neutrallight;
  box-shadow: 0px -2px 4px rgba(93, 117, 141, 0.3);
  @media (max-width: $tablet) {
    width: 100vw;
  }

  @media (min-width: $desktop) {
    min-height: 112px;
    .button {
      width: auto !important;
    }
  }

  .wrapper-buttons {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
    @media screen and (min-width: $desktop) {
      flex-direction: row;
    }
  }

  .button {
    display: block;
    flex: none;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
    height: 56px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 100px;
    &:last-child {
      margin-bottom: 8px;
    }

    @media screen and (min-width: $desktop) {
      max-width: 100%;
      width: auto;
      margin: 0 24px 0 0;
      &:last-child {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  .btn-clean {
    color: #fff;
    background-color: rgba(180, 197, 214, 0.8);
    border-color: rgba(180, 197, 214, 0.8);
  }
}
.counter {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $white;
  border-radius: 100%;
  margin-left: 12px;
  background-color: $primary;
}
</style>
